import startTour from './startTour';

export default () => startTour('startTourCourse');
